var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('div',{staticStyle:{"height":"calc(80% - 10px)"},attrs:{"id":"alarm"}})])
}]

export { render, staticRenderFns }